export default "../css/c404b458872d481dc633f61bc86d3684.ttf";